import {
    WebViewerInstance,
    Annotations as AnnotationsType,
} from '@pdftron/webviewer'

import { renumberInspectionPoint } from './logic'
export const RADIUS = 12

export const configureInspectionPoint = (
    instance: WebViewerInstance,
    createInspectionPointsToSave?: (args: {
        modelAttachmentSelectionInput: any
        modelAttachmentAnnotationInput: any
    }) => void,
    createInspectionPointsToRemove?: (args: { id: string }) => void,
    attachmentId?: string,
): void => {
    const { Annotations, annotManager, CoreControls, docViewer, Tools } =
        instance

    const InspectionPointSelection = function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        Annotations.TextMarkupAnnotation.call(this)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.Subject = 'InspectionPointSelection'
    }

    InspectionPointSelection.prototype = {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        draw: function (ctx, pageMatrix) {
            this.setStyles(ctx, pageMatrix)

            ctx.translate(this.X, this.Y)

            ctx.beginPath()
            ctx.setLineDash([])
            ctx.moveTo(0, 0)
            ctx.lineTo(0, this.Height)
            ctx.lineTo(this.Width, this.Height)
            ctx.lineTo(this.Width, 0)
            ctx.lineTo(0, 0)
            ctx.strokeStyle = 'rgb(50, 50, 50)'
            ctx.lineWidth = 1
            ctx.stroke()
        },
        // Ensures the algorithm determining how the annotation is selected is the
        // same as the Redaction tool
        selectionModel: Annotations.RedactionSelectionModel,
        setQuadsFromRect: function () {
            const rect = this.getRect()

            this['Quads'] = [
                {
                    x1: rect['x1'],
                    x2: rect['x2'],
                    x3: rect['x2'],
                    x4: rect['x1'],
                    y1: rect['y2'],
                    y2: rect['y2'],
                    y3: rect['y1'],
                    y4: rect['y1'],
                },
            ]
        },
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    InspectionPointSelection.prototype = Object.assign(
        new Annotations.TextMarkupAnnotation(),
        Annotations.CustomAnnotation.prototype,
        InspectionPointSelection.prototype,
    )

    class InspectionPointBubble extends Annotations.CustomAnnotation {
        constructor() {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            super('InspectionPointBubble')
            this.Subject = 'InspectionPointBubble'
            this.CustomData = {
                index: 1,
            }
            this.NoResize = true
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        draw(ctx, pageMatrix) {
            const degreeOfRotation = docViewer.getCompleteRotation(1)

            this.setStyles(ctx, pageMatrix)

            if (degreeOfRotation > 0) {
                ctx.translate(this.X + this.Width / 2, this.Y + this.Height / 2)

                ctx.rotate(-0.5 * degreeOfRotation * Math.PI)
                ctx.translate(-this.Width / 2, -this.Height / 2)
            } else {
                ctx.translate(this.X, this.Y)
            }

            const FONT_SIZE = 11
            const FONT_Y = 15

            ctx.beginPath()

            ctx.setLineDash([])
            ctx.ellipse(
                RADIUS + 1,
                RADIUS + 1,
                RADIUS,
                RADIUS,
                0,
                0,
                2 * Math.PI,
            )
            ctx.fillStyle = 'rgb(50, 50, 50)'
            ctx.fill()

            ctx.font = `${FONT_SIZE}px Helvetica`
            ctx.textAlign = 'center'
            ctx.fillStyle = 'white'
            ctx.fillText(
                `${this.CustomData.index || '?'}`,
                RADIUS + 1,
                FONT_Y + 1,
            )
        }
    }

    // this is necessary to set the elementName before instantiation
    InspectionPointSelection.prototype.elementName = 'inspectionPoint'
    annotManager.registerAnnotationType(
        InspectionPointSelection.prototype.elementName,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        InspectionPointSelection,
    )

    InspectionPointBubble.prototype.elementName = 'InspectionPointBubble'
    annotManager.registerAnnotationType(
        InspectionPointBubble.prototype.elementName,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        InspectionPointBubble,
    )

    // eslint-disable-next-line @typescript-eslint/no-shadow
    const InspectionPointCreateTool = function (docViewerInstance: any) {
        Tools.TextAnnotationCreateTool.call(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this,
            docViewerInstance,
            InspectionPointSelection,
        )
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.mousePtOnLeftDown = {
            x: 0,
            y: 0,
        }
    }

    InspectionPointCreateTool.prototype = Object.assign(
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        new Tools.RedactionCreateTool(),
        {
            mouseMove: function (e: MouseEvent) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                if (this.cursor === 'text') {
                    Tools.TextAnnotationCreateTool.prototype.mouseMove.call(
                        this,
                        e,
                    )
                } else {
                    Tools.GenericAnnotationCreateTool.prototype.mouseMove.call(
                        this,
                        e,
                    )
                }
            },
            mouseLeftDown: function (e: MouseEvent) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.mousePtOnLeftDown = {
                    x: e.clientX,
                    y: e.clientY,
                }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                if (this.cursor === 'text') {
                    Tools.TextAnnotationCreateTool.prototype.mouseLeftDown.call(
                        this,
                        e,
                    )
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    if (this['annotation']) {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        this['annotation']['IsText'] = true
                    }
                } else {
                    Tools.GenericAnnotationCreateTool.prototype.mouseLeftDown.call(
                        this,
                        e,
                    )
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    if (this['annotation']) {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        this['annotation']['IsText'] = false
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        this['annotation']['NoMove'] = false
                    }
                }
            },
            mouseLeftUp: async function (e: MouseEvent) {
                const { clientX: x, clientY: y } = e

                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                if (this['annotation'] && this['annotation']['IsText']) {
                    if (
                        // Behave normally if the user moved the mouse between mouseLeftDown
                        // and mouseLeftUp
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        this.mousePtOnLeftDown.x === x &&
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        this.mousePtOnLeftDown.y === y
                    ) {
                        // Do not add another annotation to the text element if one already
                        // exists
                        if (annotManager.getAnnotationByMouseEvent(e)) {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            this['annotation'] = null
                            return
                        }
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        const pageCoords = this['pageCoordinates'][0]

                        if (pageCoords) {
                            // eslint-disable-next-line @typescript-eslint/no-this-alias
                            const me = this
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            const annot = this['annotation']

                            const lineInfo =
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                await this.docViewer.getTextLineInformation(
                                    pageCoords['pageNumber'],
                                    pageCoords,
                                )

                            if (!lineInfo || !Object.keys(lineInfo).length) {
                                return
                            }
                            const { x1, y1, x2, y2 } = lineInfo.boundingBox

                            annot.setRect(
                                new CoreControls.Math.Rect(x1, y1, x2, y2),
                            )
                            annot.setQuadsFromRect()
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            me.text = lineInfo.text
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            annot._textContent = me.text
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            annot.setContents(me.text)
                            annot.setPageNumber(pageCoords['pageNumber'])
                            Tools.TextAnnotationCreateTool.prototype.mouseLeftUp.call(
                                me,
                                e,
                            )
                            annotManager.redrawAnnotation(annot)
                        }
                        return
                    }
                    Tools.TextAnnotationCreateTool.prototype.mouseLeftUp.call(
                        this,
                        e,
                    )
                } else {
                    Tools.GenericAnnotationCreateTool.prototype.mouseLeftUp.call(
                        this,
                        e,
                    )
                }
            },
        },
    )

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const inspectionPointTool = new InspectionPointCreateTool(docViewer)

    instance.registerTool({
        toolName: 'AnnotationCreateInspectionPoint',
        toolObject: inspectionPointTool,
        buttonImage:
            '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 48 48" fill="none"><defs><style>.cls-1{fill:#868e96;}</style></defs><path fill-rule="evenodd" clip-rule="evenodd" d="M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45ZM31.592 36H16.836V32.226H22.072V18.83C22.072 18.014 22.106 17.198 22.106 17.198H22.038C22.038 17.198 21.766 17.776 20.984 18.558L19.046 20.394L16.462 17.674L22.514 11.86H26.356V32.226H31.592V36Z"></path></svg>',
        buttonName: 'inspectionPointToolButton',
        tooltip: 'Inspection Point',
    })

    const renumberInspectionPoints = () => {
        const totalPages = docViewer.getPageCount()
        const annotationsList = annotManager.getAnnotationsList()
        const reDrawInspectionPoint = (
            annotation: AnnotationsType.Annotation,
        ) => {
            annotManager.redrawAnnotation(annotation)
        }

        renumberInspectionPoint({
            totalPages,
            annotationsList,
            reDrawInspectionPoint,
        })
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    inspectionPointTool.on('annotationAdded', inspectionPointSelection => {
        const inspectionPointBubble = new InspectionPointBubble()

        inspectionPointBubble.PageNumber = inspectionPointSelection.PageNumber

        inspectionPointBubble.Width = 25
        inspectionPointBubble.Height = 25
        inspectionPointBubble.Author = annotManager.getCurrentUser()
        const degreeOfRotation = docViewer.getCompleteRotation(1)

        if (degreeOfRotation == 1) {
            inspectionPointBubble.X = inspectionPointSelection.X - 25
            inspectionPointBubble.Y =
                inspectionPointSelection.Y +
                inspectionPointSelection.Height +
                10
        } else if (degreeOfRotation == 2) {
            inspectionPointBubble.X =
                inspectionPointSelection.X + inspectionPointSelection.Width + 1
            inspectionPointBubble.Y =
                inspectionPointSelection.Y + inspectionPointSelection.Height + 1
        } else if (degreeOfRotation == 3) {
            inspectionPointBubble.X =
                inspectionPointSelection.X + inspectionPointSelection.Width + 1
            inspectionPointBubble.Y = inspectionPointSelection.Y - 25
        } else {
            inspectionPointBubble.X = inspectionPointSelection.X - 27
            inspectionPointBubble.Y = inspectionPointSelection.Y - 27
        }
        const modelAttachmentAnnotationInput = {
            estimateItemUUID: null,
            attachmentId: attachmentId,
            documentPage: inspectionPointBubble.PageNumber,
            positionX: inspectionPointBubble.X,
            positionY: inspectionPointBubble.Y,
            radius: RADIUS + 1,
        }
        const modelAttachmentSelectionInput = {
            estimateItemUUID: null,
            attachmentId: attachmentId,
            userAnnotationsId: inspectionPointBubble.Id,
            documentPage: inspectionPointBubble.PageNumber,
            positionX: inspectionPointSelection.vw,
            positionY: inspectionPointSelection.ww,
            width: inspectionPointSelection.Width,
            height: inspectionPointSelection.Height,
            text: inspectionPointSelection.x7,
        }

        inspectionPointSelection.CustomData.linkedId = inspectionPointBubble.Id
        inspectionPointBubble.CustomData.linkedId = inspectionPointSelection.Id

        annotManager.addAnnotation(inspectionPointBubble)
        renumberInspectionPoints()
        // eslint-disable-next-line no-unused-expressions
        createInspectionPointsToSave?.({
            modelAttachmentSelectionInput,
            modelAttachmentAnnotationInput,
        })
    })

    annotManager.on('annotationChanged', (annotations, action, info) => {
        const { isUndoRedo, imported } = info

        if (action === 'add' && imported) {
            setTimeout(() => {
                annotations.forEach(annot => {
                    if (annot.Subject === 'InspectionPointBubble') {
                        annot.setModified(false)
                        annotManager.redrawAnnotation(annot)
                    }
                })
            }, 0)
        }
        if (action === 'delete') {
            // action: add, modify, delete
            annotations.forEach(annotation => {
                const linkedId = annotation.CustomData?.linkedId

                if (linkedId) {
                    const linkedAnnotation =
                        annotManager.getAnnotationById(linkedId)

                    if (linkedAnnotation) {
                        // eslint-disable-next-line no-unused-expressions
                        createInspectionPointsToRemove?.({
                            id:
                                annotation?.Subject ===
                                'InspectionPointSelection'
                                    ? linkedAnnotation.Id
                                    : annotation?.Id,
                        })
                        linkedAnnotation.CustomData = {}
                        annotManager.deleteAnnotation(linkedAnnotation, {
                            isUndoRedo,
                        })
                    }
                }
            })
        }
        renumberInspectionPoints()
    })
}
